"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function limitTextWithEllipsis(text, maxLength, needEllipsis) {
    if (text === void 0) { text = ''; }
    if (needEllipsis === void 0) { needEllipsis = true; }
    if (text.length > maxLength) {
        if (needEllipsis) {
            return text.slice(0, maxLength) + "...";
        }
        return "" + text.slice(0, maxLength);
    }
    return text;
}
exports.limitTextWithEllipsis = limitTextWithEllipsis;
//# sourceMappingURL=formatter.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/utils/formatter.js
// module id = 1044
// module chunks = 0